var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{staticClass:"comment-modify-modal vh100",attrs:{"name":"comment-modify-modal","width":'100%',"height":'100%',"transition":`modal-bottom`}},[_c('div',[_c('page-header',{attrs:{"BackEvent":_vm.BackEvent}}),_c('ion-content',[_c('comment-write-component',{attrs:{"boardType":'letterCommentModify',"commentData":_vm.commentData}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }